/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AcceptanceDeadline } from './AcceptanceDeadline';
import {
    AcceptanceDeadlineFromJSON,
    AcceptanceDeadlineFromJSONTyped,
    AcceptanceDeadlineToJSON,
} from './AcceptanceDeadline';
import type { AdditionalTerms1 } from './AdditionalTerms1';
import {
    AdditionalTerms1FromJSON,
    AdditionalTerms1FromJSONTyped,
    AdditionalTerms1ToJSON,
} from './AdditionalTerms1';
import type { AppraisalPeriodDays } from './AppraisalPeriodDays';
import {
    AppraisalPeriodDaysFromJSON,
    AppraisalPeriodDaysFromJSONTyped,
    AppraisalPeriodDaysToJSON,
} from './AppraisalPeriodDays';
import type { BuyerAgentCommissionFlatCents } from './BuyerAgentCommissionFlatCents';
import {
    BuyerAgentCommissionFlatCentsFromJSON,
    BuyerAgentCommissionFlatCentsFromJSONTyped,
    BuyerAgentCommissionFlatCentsToJSON,
} from './BuyerAgentCommissionFlatCents';
import type { BuyerAgentCommissionPercentage1 } from './BuyerAgentCommissionPercentage1';
import {
    BuyerAgentCommissionPercentage1FromJSON,
    BuyerAgentCommissionPercentage1FromJSONTyped,
    BuyerAgentCommissionPercentage1ToJSON,
} from './BuyerAgentCommissionPercentage1';
import type { ClientProposedTermsRequestBuyerAgentCommissionSource } from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import {
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON,
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSONTyped,
    ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON,
} from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import type { ConcessionsFlatCents } from './ConcessionsFlatCents';
import {
    ConcessionsFlatCentsFromJSON,
    ConcessionsFlatCentsFromJSONTyped,
    ConcessionsFlatCentsToJSON,
} from './ConcessionsFlatCents';
import type { ConcessionsPercentage1 } from './ConcessionsPercentage1';
import {
    ConcessionsPercentage1FromJSON,
    ConcessionsPercentage1FromJSONTyped,
    ConcessionsPercentage1ToJSON,
} from './ConcessionsPercentage1';
import type { CreateOfferRequestSource } from './CreateOfferRequestSource';
import {
    CreateOfferRequestSourceFromJSON,
    CreateOfferRequestSourceFromJSONTyped,
    CreateOfferRequestSourceToJSON,
} from './CreateOfferRequestSource';
import type { DueDiligenceFee } from './DueDiligenceFee';
import {
    DueDiligenceFeeFromJSON,
    DueDiligenceFeeFromJSONTyped,
    DueDiligenceFeeToJSON,
} from './DueDiligenceFee';
import type { EstimatedSellerNet } from './EstimatedSellerNet';
import {
    EstimatedSellerNetFromJSON,
    EstimatedSellerNetFromJSONTyped,
    EstimatedSellerNetToJSON,
} from './EstimatedSellerNet';
import type { FinancingPeriodDays } from './FinancingPeriodDays';
import {
    FinancingPeriodDaysFromJSON,
    FinancingPeriodDaysFromJSONTyped,
    FinancingPeriodDaysToJSON,
} from './FinancingPeriodDays';
import type { FinancingType } from './FinancingType';
import {
    FinancingTypeFromJSON,
    FinancingTypeFromJSONTyped,
    FinancingTypeToJSON,
} from './FinancingType';
import type { PercentOfListPrice } from './PercentOfListPrice';
import {
    PercentOfListPriceFromJSON,
    PercentOfListPriceFromJSONTyped,
    PercentOfListPriceToJSON,
} from './PercentOfListPrice';
import type { RequestSellerConcessions } from './RequestSellerConcessions';
import {
    RequestSellerConcessionsFromJSON,
    RequestSellerConcessionsFromJSONTyped,
    RequestSellerConcessionsToJSON,
} from './RequestSellerConcessions';
import type { SubmissionAdditionalTerms } from './SubmissionAdditionalTerms';
import {
    SubmissionAdditionalTermsFromJSON,
    SubmissionAdditionalTermsFromJSONTyped,
    SubmissionAdditionalTermsToJSON,
} from './SubmissionAdditionalTerms';
import type { TermsStatus } from './TermsStatus';
import {
    TermsStatusFromJSON,
    TermsStatusFromJSONTyped,
    TermsStatusToJSON,
} from './TermsStatus';

/**
 * 
 * @export
 * @interface OfferTerms
 */
export interface OfferTerms {
    /**
     * 
     * @type {string}
     * @memberof OfferTerms
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OfferTerms
     */
    offerId: string;
    /**
     * 
     * @type {CreateOfferRequestSource}
     * @memberof OfferTerms
     */
    source?: CreateOfferRequestSource;
    /**
     * 
     * @type {Date}
     * @memberof OfferTerms
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OfferTerms
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof OfferTerms
     */
    offerPrice: number;
    /**
     * 
     * @type {Array<FinancingType>}
     * @memberof OfferTerms
     */
    financingTypes: Array<FinancingType>;
    /**
     * 
     * @type {number}
     * @memberof OfferTerms
     */
    earnestMoneyDeposit: number;
    /**
     * 
     * @type {string}
     * @memberof OfferTerms
     */
    closingDate: string;
    /**
     * 
     * @type {string}
     * @memberof OfferTerms
     */
    titleCompany: string;
    /**
     * 
     * @type {number}
     * @memberof OfferTerms
     */
    dueDiligencePeriodDays?: number;
    /**
     * 
     * @type {ClientProposedTermsRequestBuyerAgentCommissionSource}
     * @memberof OfferTerms
     */
    buyerAgentCommissionSource?: ClientProposedTermsRequestBuyerAgentCommissionSource;
    /**
     * 
     * @type {BuyerAgentCommissionFlatCents}
     * @memberof OfferTerms
     */
    buyerAgentCommissionFlatCents?: BuyerAgentCommissionFlatCents;
    /**
     * 
     * @type {BuyerAgentCommissionPercentage1}
     * @memberof OfferTerms
     */
    buyerAgentCommissionPercentage?: BuyerAgentCommissionPercentage1;
    /**
     * 
     * @type {DueDiligenceFee}
     * @memberof OfferTerms
     */
    dueDiligenceFee?: DueDiligenceFee;
    /**
     * 
     * @type {RequestSellerConcessions}
     * @memberof OfferTerms
     */
    requestSellerConcessions?: RequestSellerConcessions;
    /**
     * 
     * @type {ConcessionsFlatCents}
     * @memberof OfferTerms
     */
    concessionsFlatCents?: ConcessionsFlatCents;
    /**
     * 
     * @type {ConcessionsPercentage1}
     * @memberof OfferTerms
     */
    concessionsPercentage?: ConcessionsPercentage1;
    /**
     * 
     * @type {SubmissionAdditionalTerms}
     * @memberof OfferTerms
     */
    submissionAdditionalTerms?: SubmissionAdditionalTerms;
    /**
     * 
     * @type {AdditionalTerms1}
     * @memberof OfferTerms
     */
    additionalTerms?: AdditionalTerms1;
    /**
     * 
     * @type {number}
     * @memberof OfferTerms
     */
    downPayment?: number;
    /**
     * 
     * @type {AcceptanceDeadline}
     * @memberof OfferTerms
     */
    acceptanceDeadline?: AcceptanceDeadline;
    /**
     * 
     * @type {AppraisalPeriodDays}
     * @memberof OfferTerms
     */
    appraisalPeriodDays?: AppraisalPeriodDays;
    /**
     * 
     * @type {FinancingPeriodDays}
     * @memberof OfferTerms
     */
    financingPeriodDays?: FinancingPeriodDays;
    /**
     * 
     * @type {PercentOfListPrice}
     * @memberof OfferTerms
     */
    percentOfListPrice?: PercentOfListPrice;
    /**
     * 
     * @type {EstimatedSellerNet}
     * @memberof OfferTerms
     */
    estimatedSellerNet?: EstimatedSellerNet;
    /**
     * 
     * @type {TermsStatus}
     * @memberof OfferTerms
     */
    termsStatus?: TermsStatus;
    /**
     * 
     * @type {string}
     * @memberof OfferTerms
     */
    lenderName?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferTerms
     */
    lenderContactName?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferTerms
     */
    lenderEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferTerms
     */
    lenderPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferTerms
     */
    loanId?: string;
}

/**
 * Check if a given object implements the OfferTerms interface.
 */
export function instanceOfOfferTerms(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "offerId" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "offerPrice" in value;
    isInstance = isInstance && "financingTypes" in value;
    isInstance = isInstance && "earnestMoneyDeposit" in value;
    isInstance = isInstance && "closingDate" in value;
    isInstance = isInstance && "titleCompany" in value;

    return isInstance;
}

export function OfferTermsFromJSON(json: any): OfferTerms {
    return OfferTermsFromJSONTyped(json, false);
}

export function OfferTermsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferTerms {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'offerId': json['offer_id'],
        'source': !exists(json, 'source') ? undefined : CreateOfferRequestSourceFromJSON(json['source']),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'offerPrice': json['offer_price'],
        'financingTypes': ((json['financing_types'] as Array<any>).map(FinancingTypeFromJSON)),
        'earnestMoneyDeposit': json['earnest_money_deposit'],
        'closingDate': json['closing_date'],
        'titleCompany': json['title_company'],
        'dueDiligencePeriodDays': !exists(json, 'due_diligence_period_days') ? undefined : json['due_diligence_period_days'],
        'buyerAgentCommissionSource': !exists(json, 'buyer_agent_commission_source') ? undefined : ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON(json['buyer_agent_commission_source']),
        'buyerAgentCommissionFlatCents': !exists(json, 'buyer_agent_commission_flat_cents') ? undefined : BuyerAgentCommissionFlatCentsFromJSON(json['buyer_agent_commission_flat_cents']),
        'buyerAgentCommissionPercentage': !exists(json, 'buyer_agent_commission_percentage') ? undefined : BuyerAgentCommissionPercentage1FromJSON(json['buyer_agent_commission_percentage']),
        'dueDiligenceFee': !exists(json, 'due_diligence_fee') ? undefined : DueDiligenceFeeFromJSON(json['due_diligence_fee']),
        'requestSellerConcessions': !exists(json, 'request_seller_concessions') ? undefined : RequestSellerConcessionsFromJSON(json['request_seller_concessions']),
        'concessionsFlatCents': !exists(json, 'concessions_flat_cents') ? undefined : ConcessionsFlatCentsFromJSON(json['concessions_flat_cents']),
        'concessionsPercentage': !exists(json, 'concessions_percentage') ? undefined : ConcessionsPercentage1FromJSON(json['concessions_percentage']),
        'submissionAdditionalTerms': !exists(json, 'submission_additional_terms') ? undefined : SubmissionAdditionalTermsFromJSON(json['submission_additional_terms']),
        'additionalTerms': !exists(json, 'additional_terms') ? undefined : AdditionalTerms1FromJSON(json['additional_terms']),
        'downPayment': !exists(json, 'down_payment') ? undefined : json['down_payment'],
        'acceptanceDeadline': !exists(json, 'acceptance_deadline') ? undefined : AcceptanceDeadlineFromJSON(json['acceptance_deadline']),
        'appraisalPeriodDays': !exists(json, 'appraisal_period_days') ? undefined : AppraisalPeriodDaysFromJSON(json['appraisal_period_days']),
        'financingPeriodDays': !exists(json, 'financing_period_days') ? undefined : FinancingPeriodDaysFromJSON(json['financing_period_days']),
        'percentOfListPrice': !exists(json, 'percent_of_list_price') ? undefined : PercentOfListPriceFromJSON(json['percent_of_list_price']),
        'estimatedSellerNet': !exists(json, 'estimated_seller_net') ? undefined : EstimatedSellerNetFromJSON(json['estimated_seller_net']),
        'termsStatus': !exists(json, 'terms_status') ? undefined : TermsStatusFromJSON(json['terms_status']),
        'lenderName': !exists(json, 'lender_name') ? undefined : json['lender_name'],
        'lenderContactName': !exists(json, 'lender_contact_name') ? undefined : json['lender_contact_name'],
        'lenderEmail': !exists(json, 'lender_email') ? undefined : json['lender_email'],
        'lenderPhone': !exists(json, 'lender_phone') ? undefined : json['lender_phone'],
        'loanId': !exists(json, 'loan_id') ? undefined : json['loan_id'],
    };
}

export function OfferTermsToJSON(value?: OfferTerms | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'offer_id': value.offerId,
        'source': CreateOfferRequestSourceToJSON(value.source),
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
        'offer_price': value.offerPrice,
        'financing_types': ((value.financingTypes as Array<any>).map(FinancingTypeToJSON)),
        'earnest_money_deposit': value.earnestMoneyDeposit,
        'closing_date': value.closingDate,
        'title_company': value.titleCompany,
        'due_diligence_period_days': value.dueDiligencePeriodDays,
        'buyer_agent_commission_source': ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON(value.buyerAgentCommissionSource),
        'buyer_agent_commission_flat_cents': BuyerAgentCommissionFlatCentsToJSON(value.buyerAgentCommissionFlatCents),
        'buyer_agent_commission_percentage': BuyerAgentCommissionPercentage1ToJSON(value.buyerAgentCommissionPercentage),
        'due_diligence_fee': DueDiligenceFeeToJSON(value.dueDiligenceFee),
        'request_seller_concessions': RequestSellerConcessionsToJSON(value.requestSellerConcessions),
        'concessions_flat_cents': ConcessionsFlatCentsToJSON(value.concessionsFlatCents),
        'concessions_percentage': ConcessionsPercentage1ToJSON(value.concessionsPercentage),
        'submission_additional_terms': SubmissionAdditionalTermsToJSON(value.submissionAdditionalTerms),
        'additional_terms': AdditionalTerms1ToJSON(value.additionalTerms),
        'down_payment': value.downPayment,
        'acceptance_deadline': AcceptanceDeadlineToJSON(value.acceptanceDeadline),
        'appraisal_period_days': AppraisalPeriodDaysToJSON(value.appraisalPeriodDays),
        'financing_period_days': FinancingPeriodDaysToJSON(value.financingPeriodDays),
        'percent_of_list_price': PercentOfListPriceToJSON(value.percentOfListPrice),
        'estimated_seller_net': EstimatedSellerNetToJSON(value.estimatedSellerNet),
        'terms_status': TermsStatusToJSON(value.termsStatus),
        'lender_name': value.lenderName,
        'lender_contact_name': value.lenderContactName,
        'lender_email': value.lenderEmail,
        'lender_phone': value.lenderPhone,
        'loan_id': value.loanId,
    };
}

